import 'shows/truncateToHeight';
import 'vendor/jquery.isOnScreen';
import { Swiper, Autoplay, EffectFade, Lazy, Pagination } from 'vendor/swiper.esm';
Swiper.use([Autoplay, EffectFade, Pagination]);

import { MarqueePeekAhead } from './MarqueePeekAhead';
import { trackAction } from 'helpers/trackingOM';
import { getLocale } from 'services/LocalizationService';
import ImpressionTracking, { hasImpressionTracking } from 'shared/impressionTracking';

(function () {
    window.Homepage = {};
    window.Homepage.tracking = {};
})();

import VideoHeroController from './VideoHeroController';

import { CustomMeasure } from '@cbsi-cbscom/custom-measurement';
import createLogger from '../helpers/logger';

const HERO = {
    NAMESPACE: 'WEB_MARQUEE',
    LOADED: 'LOADED',
};

const customMeasure = new CustomMeasure({ namespace: HERO.NAMESPACE });

(function () {
    customMeasure.start(HERO.LOADED);

    let heroSelector = '#hero-slider';
    let hero = $(heroSelector).not('.hero-placeholder');
    let heroContent = $('#hero-content-slider');
    let heroSpacer = $('#hero-content');
    let swiperEnabled = false;
    let heroContentSwiper;
    let heroDoc = document.querySelector(heroSelector);

    let startIndex = 0;
    let previousIndex = 0;
    let slideCount = 0;
    let scrolledOffHero = false;
    let scrolledBackOn = false;
    let numSlides = $('li.hero__slide').length - 1;
    let firstFlag = true;
    let cycleCount = 0;

    let is_paused = false;
    let _visibleHero = true;
    let userProfilesActive = false;
    let resizing = false;
    let trackVideoStartFlag = false;

    let videoHeroController;

    let bundleStatus = CBS.Registry.user.bundleStatus ? CBS.Registry.user.bundleStatus : '';

    // check if we are on a hub page (for marquee action str)
    let isHub =
        document.location.href.indexOf('/brands/') > 1 ||
        document.location.href.indexOf('/collections/') > 1;

    let itHasImpressionTracking = hasImpressionTracking();
    let impressionTracking = null;

    const peekAhead = new MarqueePeekAhead();
    const logger = createLogger('VideoHero');

    function hasSlides() {
        return isHub || CBS.Registry.homepage;
    }

    function __initImpressionTracking() {
        if (itHasImpressionTracking && swiperEnabled) {
            impressionTracking = new ImpressionTracking(hero, heroContentSwiper);
        }
    }

    // ERROR : The following function is nowhere to be found in the code.
    try {
        CBS.Registry.optimizelyHPMarquee();
    } catch (e) {}

    // measure marquee load time CBSSITE-12739
    const firstHeroImage = document.querySelector('.hero_carousel_image picture img');
    const onImageLoad = function (cached = false, failed = false) {
        const customMeasureData = {
            path: document.location.pathname,
            image: firstHeroImage.src,
            cached,
            failed,
        };

        customMeasure.end(HERO.LOADED);

        customMeasure.sendEvent({
            eventName: HERO.LOADED,
            customData: customMeasureData,
        });
    };

    const playHero = (index) => {
        const video = videoHeroController.getVideoContainer(index);

        if (video) {
            videoHeroController.playSplice(index);
        } else {
            // Use regular autoplay for images
            videoHeroController.autoplay(true);
        }
    };

    if (firstHeroImage !== null) {
        firstHeroImage.addEventListener('error', () => {
            onImageLoad(false, true);
        });

        // if image is cached, on load not called
        if (!firstHeroImage.complete) {
            firstHeroImage.addEventListener('load', () => {
                onImageLoad();
            });
        } else {
            onImageLoad(true, false);
        }
    }

    if (hero.find('.slide-js').length === 1) {
        let heroVolume = $('.hero-volume');
        heroDoc.setAttribute('data-cycle-count', cycleCount);

        videoHeroController = new VideoHeroController(heroVolume, null);
        videoHeroController.trackingEndedCallback = (videoCurrentTime) => {
            let _visibleHero = $('.hero__grid').isOnScreen();

            if (hasSlides() && _visibleHero) {
                trackVideoPreviewEnd(videoCurrentTime);
            } else {
                trackAction('trackSpliceComplete', {
                    pageType: 'show',
                    showSectionTitle: 'home',
                    showSeriesId: utag_data.showSeriesId,
                    showSeriesTitle: utag_data.showSeriesTitle,
                    contentBrand: utag_data.contentBrand,
                    spliceEnabled: '1',
                });
            }
        };

        videoHeroController.trackingPlayingCallback = () => {
            let _visibleHero = $('.hero__grid').isOnScreen();

            if (hasSlides() && _visibleHero) {
                trackVideoPreviewStart();
            } else {
                trackAction('trackSpliceView', {
                    pageType: 'show',
                    showSectionTitle: 'home',
                    showSeriesId: utag_data.showSeriesId,
                    showSeriesTitle: utag_data.showSeriesTitle,
                    contentBrand: utag_data.contentBrand,
                    spliceEnabled: '1',
                });
            }
        };

        // This will be started after video check
        playHero(0);

        if ($('.live-indicator').length && navigator.userAgent.indexOf('Win') != -1) {
            $('.live-indicator').css('lineHeight', '14px');
        }

        if ($('.live-icon-copy').length && navigator.userAgent.indexOf('Win') != -1) {
            $('.live-icon-copy').css('paddingBottom', '2px');
        }

        if ($('.reddot').length && navigator.userAgent.indexOf('Win') != -1) {
            $('.reddot').css('marginTop', '0px');
        }
    } else {
        let heroSwiper = new Swiper(hero, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: false,
            navigation: false,
            speed: 500,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            on: {
                init: function () {
                    if (typeof this.slides[0] !== 'undefined') {
                        let trackingData =
                            this.slides?.[0]?.attributes?.['data-tracking']?.value?.split('|');
                        let initTrackingTimeout = setTimeout(function () {
                            setTrackingCallbacks(videoHeroController, trackingData);
                        }, 500);

                        return;
                    }
                },
            },
        })
            .on('transitionStart', () => {
                // Using transitionStart and transitionEnd to fix aria accessibility notifications duplicated.
                const items = heroDoc.querySelectorAll('.swiper-slide');
                for (const item of items) {
                    item.setAttribute('aria-hidden', 'true');
                }
            })
            .on('transitionEnd', function () {
                if (!resizing) {
                    if (firstFlag) {
                        trackSlide(true, peekAhead.getMarqueePosterViewTrackingData());
                    }
                    trackSlide(false, peekAhead.getMarqueePosterViewTrackingData());
                }
            })
            .on('slideChange', () => {
                let _visibleHero = $('.hero__grid').isOnScreen();

                if (hasSlides() && _visibleHero) {
                    trackVideoPreviewEnd();
                }
                return;
            });

        let heroVolume = $('.hero-volume');

        heroDoc.setAttribute('data-cycle-count', cycleCount);

        heroContentSwiper = new Swiper(heroContent, {
            loop: false,
            navigation: false,
            simulateTouch: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,

                //renderBullet: function () {
                renderBullet: function (index) {
                    const indexSlide = heroSwiper.slides ? heroSwiper.slides[index] : null;
                    const trackingData = indexSlide
                        ? indexSlide.getAttribute('data-tracking')
                        : null;
                    const posColNum = indexSlide ? indexSlide.getAttribute('data-pos') : 0;
                    return `<span class="swiper-pagination-bullet" data-tracking="${trackingData}" data-pos="${posColNum}"><i></i><b></b></span>`;
                },
            },
            speed: 500,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
            slidesPerView: 1,
            slidesPerGroup: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            on: {
                init: function () {
                    setTimeout(() => {
                        peekAhead.initBulletCarousel(this, heroSelector);
                        if (!peekAhead.isFeatureEnabled) {
                            // initialize event listener to track marquee pagination select
                            marqueePaginationEventSetup();
                        }

                        let trackingData = this.slides?.[0]?.dataset?.tracking?.split('|');
                        let isMovie = trackingData?.[5] == 'movie';
                        let posColNum = this.slides?.[0]?.dataset?.pos?.toString() ?? '';
                        trackingData = {
                            slideId: trackingData[12] ?? '',
                            slideTitle: trackingData[13] ?? '',
                            showSeriesId: !isMovie ? (trackingData[6] ?? '') : '',
                            showSeriesTitle: !isMovie ? (trackingData[13] ?? '') : '',
                            movieId:
                                isMovie || trackingData?.[6] == '61457287'
                                    ? (trackingData[9] ?? '')
                                    : '',
                            movieTitle: isMovie ? (trackingData[10] ?? '') : '',
                            posColNum: posColNum,
                        };
                        let displayId = this.slides?.[0]?.dataset?.displayid?.toString();
                        trackMarquee(trackingData, isMovie, displayId);
                    }, 10);
                },
            },
        })
            .on('transitionStart', function () {
                //heroSwiper.slideTo(this.activeIndex);
            })
            .on('slideChange', async function () {
                let _visibleHero = $('.hero__grid').isOnScreen();

                logger.log('Slide change');

                if (hasSlides() && _visibleHero) {
                    trackVideoPreviewEnd();
                }

                heroSwiper.slideTo(this.realIndex);
                await videoHeroController.reset(false);

                playHero(this.realIndex);

                const currentSlide = heroSwiper.slides[this.realIndex];
                let trackingData = currentSlide.attributes['data-tracking'].value.split('|');
                setTrackingCallbacks(videoHeroController, trackingData);
            })
            .on('reachBeginning', function () {
                cycleCount++;
                heroDoc.setAttribute('data-cycle-count', cycleCount);
            });

        videoHeroController = new VideoHeroController(heroVolume, heroContentSwiper);
        // This will be started after video check
        heroContentSwiper.autoplay.stop();
        playHero(0);

        is_paused = false;
        let complementaryLandmark = $(
            `<aside id="carousel-pause-button__container" aria-label="${getLocale(
                'carousel_pause_play_button',
            )}"></aside>`,
        );
        let pauseCarousel = $(`<button tabindex="0">${getLocale('pause_carousel')}</button>`);
        pauseCarousel.attr({
            id: 'carousel-pause-button',
        });

        complementaryLandmark.append(pauseCarousel);
        $('#main-container').prepend(complementaryLandmark);

        $('#carousel-pause-button').on('click', function (e) {
            if (is_paused) {
                videoHeroController.stopHero(true, true);
                $(this).text('Pause Carousel');
            } else {
                videoHeroController.stopHero(false);
                $(this).text('Play Carousel');
            }
            is_paused = !is_paused;
        });

        if (!CBS.Registry.platform.isMobile) {
            // heroSpacer
            //  .mouseenter(function () {
            //     videoHeroController.stopHero(true, true)
            // })
            //  .mouseleave(function () {
            //     videoHeroController.stopHero(false)
            // });
        }

        $(window).scroll(debounce(() => handleScroll()));

        $(document).ready(function () {
            //to handle when Who's Watching SPECIFICALLY automatically loads at the beginning
            let userProfileFlag = $('#who-s-watching');
            if (userProfileFlag.length > 0) {
                setTimeout(() => {
                    //give content time to start, otherwise it will start after you tell it to stop...
                    videoHeroController.stopHero(true, true);
                    heroContentSwiper.autoplay.stop();
                    is_paused = true;
                    userProfilesActive = true;
                }, 3000);
            }
        });

        window.addEventListener(
            //to handle when user manually turns User Profiles on
            'userProfilesOn',
            function (evt) {
                //when User Profiles are engaged stop the carousel from sliding slides
                videoHeroController.stopHero(true, true);
                heroContentSwiper.autoplay.stop();
                is_paused = true;
                userProfilesActive = true;
            },
            false,
        );

        window.addEventListener(
            //handles when User Profiles turn off, should the page not reload for any reason.
            'userProfilesOff',
            function (evt) {
                //when User Profiles are not engaged let the marquee know
                userProfilesActive = false;
            },
            false,
        );

        swiperEnabled = true;

        // Impression tracking
        __initImpressionTracking();
    }

    //suppress over-reporting tracking impressions on window.resize
    let timeout = false;
    function resizeDebounced() {
        resizing = false;
    }
    window.addEventListener('resize', function () {
        resizing = true;
        clearTimeout(timeout);
        timeout = setTimeout(resizeDebounced, 4000);
    });

    function handleScroll() {
        _visibleHero = $('.hero__grid').isOnScreen();

        if (!_visibleHero) {
            if (swiperEnabled && window.innerWidth > 1023) {
                if (hasSlides()) {
                    trackVideoPreviewEnd();
                    videoHeroController.pauseSplice();
                } else {
                    videoHeroController.stopHero(true, true);
                }
                scrolledOffHero = true;
                is_paused = true;
                cycleCount = 0;
            }
        } else {
            if (swiperEnabled && window.innerWidth > 1023) {
                if (hasSlides()) {
                    trackVideoPreviewStart();
                    videoHeroController.resumeSplice();
                } else {
                    videoHeroController.stopHero(false);
                }
                scrolledOffHero = false;
                is_paused = false;
            }
        }
    }

    function setTrackingCallbacks(videoHeroController, trackingData) {
        videoHeroController.trackingEndedCallback = (videoCurrentTime) => {
            let _visibleHero = $('.hero__grid').isOnScreen();
            if (!userProfilesActive && _visibleHero) {
                trackVideoPreviewEnd(videoCurrentTime);
            }
        };

        videoHeroController.trackingPlayingCallback = () => {
            let _visibleHero = $('.hero__grid').isOnScreen();
            if (!userProfilesActive && _visibleHero) {
                trackVideoPreviewStart();
            }
        };

        videoHeroController.trackingVolumeCallback = (actionType) => {
            let _posColNum = trackingData[4] - 1;
            trackAction(actionType, {
                slideId: trackingData[12],
                slideTitle: trackingData[13],
                slideTarget: trackingData[14],
                slideCTA: trackingData[3],
                slideType: trackingData[15],
                rowHeaderTitle: 'Home Marquee',
                posRowNum: '0',
                posColNum: _posColNum.toString(),
                slideCycle: cycleCount.toString(),
                optimizelyEp: CBS.Tracking.utag_data.optimizelyExp,
                showSectionTitle: 'home',
                showSeriesId: trackingData[6],
                showSeriesTitle: trackingData[7],
                showEpisodeId: '',
                showEpisodeTitle: '',
                movieId: trackingData[9],
                movieTitle: trackingData[10],
                movieSectionTitle: 'home',
                contentLocked: trackingData[17],
                dma: trackingData[18],
                bundleStatus: bundleStatus,
            });
        };
    }

    function debounce(func, timeout = 250) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    function trackSlide(_initialSlide, additionalTrackingData = {}) {
        let item =
            firstFlag && typeof $('li.swiper-slide-active')[0] !== 'undefined'
                ? $('li.swiper-slide-prev')[0]
                : $('li.swiper-slide-active')[0];
        let itemCTA = $('li.swiper-slide-active .cta-box > a')[0];
        if (_initialSlide) {
            firstFlag = false;
        }

        if (item) {
            let dd = item.getAttribute('data-tracking').split('|');
            let displayId = item.dataset?.displayId ?? item.dataset?.displayid ?? '';
            let _screenName = $('#global-header-container .user-profile-name').text() ?? '';
            let spliceEnabled = $('.hero__wrapper .swiper-slide-active .marqueeVideo').length
                ? '1'
                : '0';

            item.setAttribute('aria-hidden', 'false');

            let visibleHero = $('.hero__grid').isOnScreen();

            if (dd !== undefined && visibleHero) {
                let isMovie = dd[5] === 'movie';
                let posColNum = item.getAttribute('data-pos');
                let action = 'trackMarqueeView';

                let obj = {
                    liveTvChannel: 'undefined',
                    slideId: dd[12],
                    slideTitle: dd[13],
                    slideTarget: dd[14],
                    slideCTA: dd[3],
                    slideType: dd[15] ?? '',
                    rowHeaderTitle: 'Home Marquee',
                    posRowNum: '0',
                    posColNum: posColNum.toString(),
                    slideCycle: cycleCount.toString(),
                    showSectionTitle: !isMovie ? 'home' : '',
                    showSeriesId: !isMovie ? dd[6] : '',
                    showSeriesTitle: !isMovie ? dd[13] : '',
                    showGenre: !isMovie ? dd[11] : '',
                    screenName: _screenName,
                    contentBrand: dd[8] ?? '',
                    movieSectionTitle: isMovie ? 'home' : '',
                    movieId: isMovie || dd[6] == '61457287' ? dd[9] : '',
                    movieTitle: isMovie ? dd[10] : '',
                    movieGenre: isMovie ? dd[11] : '',
                    spliceEnabled: spliceEnabled,
                    contentLocked: dd[17],
                    bundleStatus: bundleStatus,
                    videoPreviewId: dd[18],
                    dma: dd[19],
                    isPvr: dd[20],
                    ...additionalTrackingData,
                };

                if (isHub) {
                    action = 'trackHubMarqueeView';
                    obj.rowHeaderTitle = 'Hub Marquee';
                    obj.hubId = CBS.Tracking.utag_data.hubId ? CBS.Tracking.utag_data.hubId : '';
                    obj.hubSlug = CBS.Tracking.utag_data.hubSlug
                        ? CBS.Tracking.utag_data.hubSlug
                        : '';
                    obj.hubPageType = CBS.Tracking.utag_data.hubPageType
                        ? CBS.Tracking.utag_data.hubPageType
                        : '';

                    if (
                        itemCTA &&
                        itemCTA.hasOwnProperty('href') &&
                        itemCTA.href.indexOf('live-tv') > -1
                    ) {
                        let liveTvChannel = dd[13];
                        if (itemCTA.href.indexOf('stream/cbsn') > 1) {
                            liveTvChannel = 'CBSN Live Stream';
                        } else if (itemCTA.href.indexOf('stream') > 1) {
                            liveTvChannel = 'Live Local TV';
                        }
                        obj.liveTvChannel = liveTvChannel;
                    }
                }

                try {
                    if (_visibleHero && slideCount < 50) {
                        trackAction(action, obj);
                        slideCount++;
                    }

                    if (_visibleHero && slideCount < 100) {
                        trackMarquee(obj, isMovie, displayId);
                        if (slideCount > 50) slideCount++;
                    }
                } catch (e) {
                    console.error(action + ' failed to load');
                }
            }
        }
    }

    function trackVideoPreviewStart() {
        let $activeSlide = getActiveSlide();
        let video = $activeSlide.find('video')[0];

        if (!trackVideoStartFlag && video !== undefined) {
            let dd = $activeSlide.attr('data-tracking').split('|');
            let action = 'trackVideoPreviewStart';
            let posColNum = $activeSlide.attr('data-pos');
            let isMovie = dd[5] === 'movie';
            let _screenName = $('#global-header-container .user-profile-name').text() ?? '';
            let rowHeaderTitle = 'Home Marquee';
            let elapsedTime = Math.trunc(video.currentTime).toString() ?? '0';

            let obj = {
                liveTvChannel: 'undefined',
                slideId: dd[12],
                slideTitle: dd[13],
                slideTarget: dd[14],
                slideCTA: dd[3],
                videoPreviewId: dd[18],
                contentLocked: dd[17],
                slideType: dd[15],
                rowHeaderTitle: rowHeaderTitle,
                posRowNum: '0',
                posColNum: posColNum,
                slideCycle: cycleCount.toString(),
                showSeriesId: !isMovie ? dd[6] : '',
                showSeriesTitle: !isMovie ? dd[13] : '',
                showGenre: !isMovie ? dd[11] : '',
                screenName: _screenName,
                contentBrand: dd[8],
                movieSectionTitle: isMovie ? 'home' : '',
                movieId: isMovie || dd[6] == '61457287' ? dd[9] : '',
                movieTitle: isMovie ? dd[10] : '',
                movieGenre: isMovie ? dd[11] : '',
                elapsedTime: elapsedTime,
                dma: dd[19],
                isPvr: dd[20],
            };

            if (isHub) {
                obj.rowHeaderTitle = 'Hub Marquee';
                obj.hubId = CBS.Tracking.utag_data.hubId ? CBS.Tracking.utag_data.hubId : '';
                obj.hubSlug = CBS.Tracking.utag_data.hubSlug ? CBS.Tracking.utag_data.hubSlug : '';
                obj.hubPageType = CBS.Tracking.utag_data.hubPageType
                    ? CBS.Tracking.utag_data.hubPageType
                    : '';
            }

            trackAction(action, obj);
            trackVideoStartFlag = true;
        }
    }

    function trackVideoPreviewEnd(videoCurrentTime) {
        let $activeSlide = getActiveSlide();
        let video = $activeSlide.find('video')[0];

        if (trackVideoStartFlag && video !== undefined) {
            let dd = $activeSlide.attr('data-tracking').split('|');
            let action = 'trackVideoPreviewEnd';
            let posColNum = $activeSlide.attr('data-pos');
            let isMovie = dd[5] === 'movie';
            let _screenName = $('#global-header-container .user-profile-name').text() ?? '';
            let rowHeaderTitle = 'Home Marquee';
            let currentTime = videoCurrentTime ?? video.currentTime;
            let elapsedTime = Math.trunc(currentTime).toString() ?? '0';

            let obj = {
                liveTvChannel: 'undefined',
                slideId: dd[12],
                slideTitle: dd[13],
                slideTarget: dd[14],
                slideCTA: dd[3],
                videoPreviewId: dd[18],
                contentLocked: dd[17],
                slideType: dd[15],
                rowHeaderTitle: rowHeaderTitle,
                posRowNum: '0',
                posColNum: posColNum,
                slideCycle: cycleCount.toString(),
                showSeriesId: !isMovie ? dd[6] : '',
                showSeriesTitle: !isMovie ? dd[13] : '',
                showGenre: !isMovie ? dd[11] : '',
                screenName: _screenName,
                contentBrand: dd[8],
                movieSectionTitle: isMovie ? 'home' : '',
                movieId: isMovie || dd[6] == '61457287' ? dd[9] : '',
                movieTitle: isMovie ? dd[10] : '',
                movieGenre: isMovie ? dd[11] : '',
                elapsedTime: elapsedTime,
                dma: dd[19],
                isPvr: dd[20],
            };

            if (isHub) {
                obj.rowHeaderTitle = 'Hub Marquee';
                obj.hubId = CBS.Tracking.utag_data.hubId ? CBS.Tracking.utag_data.hubId : '';
                obj.hubSlug = CBS.Tracking.utag_data.hubSlug ? CBS.Tracking.utag_data.hubSlug : '';
                obj.hubPageType = CBS.Tracking.utag_data.hubPageType
                    ? CBS.Tracking.utag_data.hubPageType
                    : '';
            }

            trackAction(action, obj);
            trackVideoStartFlag = false;
        }
    }

    function marqueePaginationEventSetup() {
        document.querySelectorAll('.swiper-pagination-bullet').forEach((element) => {
            element.addEventListener('click', (e) => {
                let trackingData = element.getAttribute('data-tracking');
                let posColNum = element.getAttribute('data-pos');
                trackMarqueeSelection(trackingData, posColNum);
            });
        });
    }

    function trackMarqueeSelection(data, posColNum) {
        let action = 'trackMarqueePaginationSelect';

        let dd = data.split('|');
        let _screenName = $('#global-header-container .user-profile-name').text() ?? '';
        let spliceEnabled = $('.hero__wrapper .swiper-slide-active .marqueeVideo').length
            ? '1'
            : '0';

        if (dd !== undefined) {
            let isMovie = dd[5] === 'movie';

            let obj = {
                liveTvChannel: 'undefined',
                slideId: dd[12],
                slideTitle: dd[13],
                slideTarget: dd[14],
                slideCTA: dd[3],
                slideType: dd[15] ?? '',
                rowHeaderTitle: 'Home Marquee',
                posRowNum: '0',
                posColNum: posColNum.toString(),
                slideCycle: cycleCount.toString(),
                showSectionTitle: !isMovie ? 'home' : '',
                showSeriesId: !isMovie ? dd[6] : '',
                showSeriesTitle: !isMovie ? dd[13] : '',
                showGenre: !isMovie ? dd[11] : '',
                screenName: _screenName,
                contentBrand: dd[8] ?? '',
                movieSectionTitle: isMovie ? 'home' : '',
                movieId: isMovie || dd[6] == '61457287' ? dd[9] : '',
                movieTitle: isMovie ? dd[10] : '',
                movieGenre: isMovie ? dd[11] : '',
                spliceEnabled: spliceEnabled,
                contentLocked: dd[17],
                bundleStatus: bundleStatus,
                videoPreviewId: dd[18],
                dma: dd[19],
            };

            trackAction(action, obj);
        }
    }

    function trackMarquee(trackingData, isMovie, displayId, trackAction = 'marqueeView') {
        if (itHasImpressionTracking && impressionTracking && _visibleHero) {
            const marqueeObj = buildMarqueeObject(trackingData, isMovie, displayId);
            impressionTracking.updateImpressionTrackingMarquee(marqueeObj, trackAction);
        }
    }

    function buildMarqueeObject(obj, isMovie, displayId) {
        return [
            {
                containerId: obj.slideId,
                containerTitle: obj.slideTitle,
                containerType: isHub ? 'hub marquee' : 'homeSlide',
                displayId: displayId,
                rowNum: '0',
                rankModel: '',
                pvrModel: '',
                items: [
                    {
                        id: isMovie ? obj.movieId : obj.showSeriesId,
                        title: isMovie ? obj.movieId : obj.showSeriesId,
                        type: isMovie ? obj.movieTitle : obj.showSeriesTitle,
                        position: obj.posColNum,
                        badgeLabel: '',
                        isUnlocked: '',
                        cmsId: isMovie ? obj.movieId : obj.showSeriesId,
                    },
                ],
            },
        ];
    }

    //setupParallax(); disabling too choppy will revisit

    runTruncateDescription();

    function setupParallax() {
        $(window).scroll(function () {
            let scrollPos = $(window).scrollTop();

            if (scrollPos > 0) {
                if (swiperEnabled) {
                    heroContentSwiper.autoplay.stop();
                }

                if (scrollPos > 200) {
                    // pausing vilynx
                    pauseVilynx(hero.find('.vilynx_enabled'));
                } else {
                    //  resuming vilynx
                    resumeVilynx(hero.find('.vilynx_enabled'));
                }
            } else {
                if (swiperEnabled) {
                    heroContentSwiper.autoplay.start();
                }
            }

            hero.css('transform', 'translateY(' + -scrollPos / 6.5 + 'px)');
        });
    }

    function pauseVilynx(target) {
        if (!target.hasClass('vilynx_stop')) {
            target.addClass('vilynx_stop');
        }
    }

    function resumeVilynx(target) {
        if (target.hasClass('vilynx_stop')) {
            target.removeClass('vilynx_stop');
        }
    }

    function getActiveSlide() {
        let $activeSlide = $('.hero__wrapper .swiper-slide-active');

        if ($activeSlide.length == 0) {
            let firstItem = $('.hero__wrapper .swiper-slide')[0];
            $activeSlide = $(firstItem);
        }

        return $activeSlide;
    }

    function runTruncateDescription() {
        let el = document.getElementById('hero-description');

        if (el && typeof el.style.webkitLineClamp === 'undefined') {
            TruncateToHeight.truncate({
                heightElementId: 'hero-description-box',
                contentElementId: 'hero-description',
            });
        }
    }
    $('.swiper-wrapper .swiper-slide .hero__content-slide-wrapper .button').on(
        'click',
        function (event) {
            let $item = $(this);
            let item = $item[0];
            let data = $item.attr('aa-link'); //original click link
            let aaLink = data.split('|');
            let $activeSlide = getActiveSlide();
            let displayId = $activeSlide[0]?.getAttribute('data-displayid') ?? '';
            let spliceEnabled = $activeSlide.find('.marqueeVideo').length ? '1' : '0';
            localStorage.setItem('spliceEnabled', spliceEnabled);
            let preRowHeaderTitle;
            let rowHeaderT;

            if (CBS.Registry.homepage) {
                trackVideoPreviewEnd();
                try {
                    let item = $('li.swiper-slide-active')[0];
                    let itemCTA = $('li.swiper-slide-active .cta-box > a')[0];
                    let dd = $activeSlide[0].getAttribute('data-tracking').split('|');
                    // START AB TEST feature/PLGRWEB-1714-hp-marquee-watch-now-and-got-to-details-epic
                    if (CBS.AbTestsConfigs?.modules?.HomePageMarqueeUserPath?.inVariants) {
                        const itemTracking = $item.attr('data-tracking');
                        const itemTrackingCta = itemTracking.split('|')[0];
                        dd[3] = itemTrackingCta ?? dd[3];
                    }
                    // END AB TEST feature/PLGRWEB-1714-hp-marquee-watch-now-and-got-to-details-epic
                    let _screenName = $('#global-header-container .user-profile-name').text() ?? '';
                    let posColNum = $activeSlide.attr('data-pos');
                    let isMovie = dd[5] === 'movie';
                    let isPvr = $activeSlide.attr('data-pvr')
                        ? $activeSlide.attr('data-pvr')
                        : 'false';

                    preRowHeaderTitle = isMovie ? 'movie hero' : 'show hero';
                    if (aaLink[0] == 'marquee') {
                        preRowHeaderTitle = 'marquee';
                    }

                    rowHeaderT = CBS.Registry.homepage ? 'Home Marquee' : preRowHeaderTitle;

                    let action = 'trackMarqueeSelect';

                    let obj = {
                        liveTvChannel: 'undefined',
                        slideId: dd[12],
                        slideTitle: dd[13],
                        slideTarget: dd[14],
                        ctaText: aaLink[2],
                        isPvr: isPvr,
                        slideCTA: dd[3],
                        slideType: dd[15] ?? '',
                        rowHeaderTitle: rowHeaderT,
                        posRowNum: '0',
                        posColNum: posColNum,
                        slideCycle: cycleCount.toString(),
                        showSectionTitle: !isMovie ? 'home' : '',
                        showSeriesId: !isMovie ? dd[6] : '',
                        showSeriesTitle: !isMovie ? aaLink[4] : '',
                        showGenre: !isMovie ? dd[11] : '',
                        showDayPart: 'undefined',
                        showEpisodeId:
                            typeof aaLink[16] === 'undefined' && !isMovie
                                ? 'undefined'
                                : aaLink[16],
                        showEpisodeTitle: aaLink[4] && !isMovie ? aaLink[4] : '',
                        showEpisodeLabel: aaLink[4] && !isMovie ? aaLink[4] : '',
                        showSeasonNumber: aaLink[6] && !isMovie ? aaLink[6] : '',
                        showEpisodeNumber: aaLink[7] && !isMovie ? aaLink[7] : '',
                        showAirDate: aaLink[8],
                        screenName: _screenName.toString(),
                        contentBrand: dd[8] ?? '',
                        movieSectionTitle: isMovie ? 'home' : '',
                        movieId: isMovie ? dd[9] : '',
                        movieTitle: isMovie ? dd[10] : '',
                        movieGenre: isMovie ? dd[11] : '',
                        optimizelyExp: CBS.Tracking.utag_data.optimizelyExp,
                        spliceEnabled: spliceEnabled,
                        contentLocked: dd[17],
                        bundleStatus: bundleStatus,
                        videoPreviewId: dd[18],
                        dma: dd[19],
                        ...peekAhead.getMarqueePosterViewTrackingData(),
                    };

                    if (
                        itemCTA &&
                        itemCTA.getAttribute('href') !== undefined &&
                        itemCTA.href.indexOf('live-tv') > -1
                    ) {
                        let liveTvChannel = 'undefined';
                        if (itemCTA.href.indexOf('stream/cbsn') > 1) {
                            liveTvChannel = 'CBSN Live Stream';
                        } else if (itemCTA.href.indexOf('stream') > 1) {
                            liveTvChannel = 'Live Local TV';
                        }
                        obj.liveTvChannel = liveTvChannel;
                    }

                    trackAction(action, obj);
                    trackMarquee(obj, isMovie, displayId, 'marqueeSelect');
                } catch (e) {
                    console.log('error - ' + event);
                }
            } else {
                let data = $item.attr('aa-link');
                //var d = data.split('|');
                let bUrl = $item.attr('href');
                try {
                    let aaLink = data.split('|');
                    let posColNum = $activeSlide.attr('data-pos');

                    let __contentBrand = aaLink[10];
                    __contentBrand = __contentBrand !== '' ? __contentBrand : 'na';

                    preRowHeaderTitle = isMovie ? 'movie hero' : 'show hero';
                    rowHeaderT = CBS.Registry.homepage ? 'Home Marquee' : preRowHeaderTitle;

                    let showSeriesTitle = aaLink[4];
                    if (aaLink[22] != '') {
                        showSeriesTitle = aaLink[4] + ' ' + aaLink[22];
                    }

                    let isMovie =
                        typeof CBS.Registry.MovieTitle !== 'undefined' || aaLink[20] === 'movie';

                    preRowHeaderTitle = isMovie ? 'movie hero' : 'show hero';
                    if (aaLink[0] == 'marquee') {
                        preRowHeaderTitle = 'marquee';
                    }

                    let rowHeaderT = CBS.Registry.homepage ? 'Home Marquee' : preRowHeaderTitle;
                    var mobj = {
                        posRowNum: '0',
                        posColNum: posColNum.toString(),
                        contentLocked: aaLink[23],
                        dma: aaLink[24],
                        liveTvChannel: 'undefined',
                        showSectionTitle: !isMovie ? 'home' : '',
                        showSeriesId: !isMovie ? aaLink[11] : '',
                        showSeriesTitle: !isMovie ? showSeriesTitle : '',
                        showGenre: !isMovie ? aaLink[15] : '',
                        showDayPart: 'undefined',
                        showEpisodeId:
                            typeof aaLink[16] === 'undefined' && !isMovie
                                ? 'undefined'
                                : aaLink[16],
                        showEpisodeTitle: aaLink[5] && !isMovie ? aaLink[5] : '',
                        showEpisodeLabel: aaLink[5] && !isMovie ? aaLink[5] : '',
                        showSeasonNumber: aaLink[6] && !isMovie ? aaLink[6] : '',
                        showEpisodeNumber: aaLink[7] && !isMovie ? aaLink[7] : '',
                        showAirDate: aaLink[8],
                        ctaText: aaLink[2],
                        targetURL: bUrl,
                        targetType: aaLink[2] + '|' + bUrl,
                        assetTitle: isMovie ? aaLink[5] : aaLink[4],
                        rowHeaderTitle: rowHeaderT,
                        contentBrand: __contentBrand,
                        movieId: isMovie ? aaLink[11] : '',
                        movieTitle: isMovie ? aaLink[5] : '',
                        movieGenre: isMovie ? aaLink[15] : '',
                        optimizelyExp: CBS.Tracking.utag_data.optimizelyExp,
                        spliceEnabled: spliceEnabled,
                    };

                    // badge type and lock state (if set) @todo duplicate in JsCarousel.js reuse?
                    mobj[aaLink[13] === 'p' ? 'PPlusSubscriberBadge' : 'TVELockedBadge'] =
                        aaLink[14];

                    let action =
                        CBS.Registry.homepage || CBS.Registry.kidsLanding
                            ? 'trackMarqueeSelect'
                            : 'trackShowHero';

                    if (action === 'trackShowHero') {
                        mobj.resumeRestartIsPresent =
                            aaLink[2].toLowerCase() === getLocale('watch_now_').toLowerCase()
                                ? '0'
                                : '1';
                    }

                    if (isHub) {
                        action = 'trackHubMarqueeSelect';

                        mobj.videoPreviewId = aaLink[24];
                        ((mobj.slideType = aaLink[17]),
                            (mobj.slideCycle = cycleCount.toString()),
                            (mobj.slideId = aaLink[19]),
                            (mobj.slideTitle = isMovie ? aaLink[5] : aaLink[4]),
                            (mobj.slideTarget = bUrl),
                            (mobj.slideCTA = aaLink[2]),
                            (mobj.rowHeaderTitle = 'Hub Marquee'));
                        mobj.hubId = CBS.Tracking.utag_data.hubId
                            ? CBS.Tracking.utag_data.hubId
                            : '';
                        mobj.hubSlug = CBS.Tracking.utag_data.hubSlug
                            ? CBS.Tracking.utag_data.hubSlug
                            : '';
                        mobj.hubPageType = CBS.Tracking.utag_data.hubPageType
                            ? CBS.Tracking.utag_data.hubPageType
                            : '';

                        if (
                            item &&
                            item.hasOwnProperty('href') &&
                            item.href.indexOf('live-tv') > -1
                        ) {
                            let liveTvChannel = aaLink[13];
                            if (item.href.indexOf('stream/cbsn') > 1) {
                                liveTvChannel = 'CBSN Live Stream';
                            } else if (item.href.indexOf('stream') > 1) {
                                liveTvChannel = 'Live Local TV';
                            }
                            mobj.liveTvChannel = liveTvChannel;
                        }
                    }

                    localStorage.setItem(
                        'trackHeroCtaText',
                        JSON.stringify({ ctaText: mobj.ctaText }),
                    );
                    window.localStorage.setItem('metadata-video-tracking', JSON.stringify(mobj));

                    trackAction(action, mobj);
                    trackMarquee(mobj, isMovie, displayId, 'marqueeSelect');
                } catch (e) {
                    console.log(e);
                }
            }
        },
    );

    /* add class to hero bullet if it comes into focus */
    $('.swiper-pagination .swiper-pagination-bullet').focus(function () {
        $(this).addClass('got-focus');
    });

    /* remove class when hero bullet with got-focus class comes into focus  */
    $('body').on(
        'keypress',
        '.swiper-pagination .swiper-pagination-bullet.got-focus',
        function (e) {
            var keycode = e.keyCode ? e.keyCode : e.which;
            if (keycode == '13') {
                $(this).removeClass('got-focus');
            }
        },
    );

    /* making sure keyboard tab only focus on the actual slide and not the duplicates */
    $('.swiper-slide-duplicate a').attr('tabindex', '-1');

    /* track which Hero CTA is in focused and slide to that marquee */
    /* Disabling this for now - causing an issue on mweb
    $('.hero__content-slide-wrapper .cta-box a').focus(function () {
        let i = $(this).parents(':eq(2)').data('swiper-slide-index');
        let mySwiper = document.querySelector('#hero-content-slider').swiper;
        if (mySwiper) mySwiper.slideToLoop(i);
    });
    */
})();
